import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { STATUS } from '../models/status';
import { HttpService } from './http.service';

@Injectable()
export class MovementsService {
  constructor(private http: HttpService) {}

  getMovements(bank: string, filters: any) {
    let params = new HttpParams();

    if (filters?.fechaInicio) {
      params = params.set('fechaInicio', filters.fechaInicio);
    }

    if (filters?.fechaFin) {
      params = params.set('fechaFin', filters.fechaFin);
    }

    const baseUrl = `movements/${bank}`; // Adjust the base URL as needed
    return this.http.get(baseUrl, params);
  }
}
